import React, { useEffect } from 'react';
import {connect, useSelector} from "react-redux";
import {getStateByPath} from "../../../redux/selectors";

// components
import AdmissionList from "./_list";
import {showLoader} from "../../../components/loader/loader";

// actions
import {ADD_STATE, REMOVE_STATE, setApp, setUdn, setUserIsAdmin} from "../../../redux/actions/generics/IndexedActions";

const Admission = props => {
    const path = props.path || 'core/admission';
    const componentState = useSelector(state => getStateByPath(state, path));
    const { loading } = componentState?.data || false;

    useEffect(() => {
        props.ADD_STATE(path);

        return () => {
            props.REMOVE_STATE(path);
        }
    }, []);

    useEffect(() => {
        const _udn = localStorage.getItem('selectedUdn') !== '' ? JSON.parse(localStorage.getItem('selectedUdn')) : null
        if (_udn !== null)
            props.setUdn(path, _udn);

        if (props.app !== null)
            props.setApp(path, props.app);
    },[]);

    return <>
        {loading && showLoader()}
        { componentState && <AdmissionList path={path} /> }
    </>
}

const mapStateToProps = state => ({ })
const mapActionsToProps = ({
    ADD_STATE,
    REMOVE_STATE,
    setUdn,
    setApp,
    setUserIsAdmin
})

export default connect(mapStateToProps, mapActionsToProps)(Admission)
